import { endpoints } from "constant";
import { apiAction } from "store/middlewares/api.middleware.helper";
import { EMethods } from "store/store.interface";
import {
  GET_SHIPMENT_SERVICES,
  SET_SHIPMENT_SERVICES,
  SET_SELECTED_SHIPMENTS,
} from "store/store.types";
import { Dispatch } from "redux";

export const getShipmentServices = () => (dispatch: Dispatch<any>) => {
  const endpoint = process.env.REACT_APP_AGENT_ZERO_API + endpoints.SHIPMENT_SERVICES;
  dispatch(
    apiAction({
      label: GET_SHIPMENT_SERVICES,
      method: EMethods.GET,
      url: endpoint,
      isAbsoluteUrl: true,
      isStatic: true,
      data: {},
      headers: {
        "clientid": "promotion-engine"
      },
      withToken: true,
      onSuccess: ({ data })=>(dispatch: Dispatch) => dispatch({
        type: SET_SHIPMENT_SERVICES,
        payload: data,
      }),
    })
  );
};

export const setSelectedShipments = (selectedShipments: any) => ({
  type: SET_SELECTED_SHIPMENTS,
  payload: selectedShipments,
});

export const setMarketplaceValues = (values: any) => ({
  type: 'SET_MARKETPLACE_VALUES',
  payload: values
});
